import { shouldReloadOnce } from './sw-recovery';

/**
 * A lazy chunk that no longer exists on the server.
 *
 * With the service worker off (v5.66.7), a tab left open across a deploy keeps
 * running the old build. Its lazy routes still point at the old chunk names,
 * which the new build no longer serves, so the first visit to such a route
 * fails with this error. A full page load fetches the new index.html
 * (no-cache) and with it the new chunk names.
 *
 * The message differs per browser; webpack's ChunkLoadError is kept for safety.
 */
const CHUNK_ERROR =
  /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Loading chunk [\w-]+ failed|ChunkLoadError/i;

export const CHUNK_RELOAD_KEY = 'chunk-load-error-reloaded-at';

export function isChunkLoadError(error: unknown): boolean {
  if (!error) return false;
  const text =
    typeof error === 'string'
      ? error
      : `${(error as { name?: string }).name ?? ''} ${(error as { message?: string }).message ?? ''}`;
  return CHUNK_ERROR.test(text);
}

/** Reload at most once per window — a chunk that is missing for good must not loop. */
export function shouldReloadForChunkError(
  storage: Pick<Storage, 'getItem' | 'setItem'> | null | undefined,
  now: number,
  windowMs = 60_000
): boolean {
  return shouldReloadOnce(storage, CHUNK_RELOAD_KEY, now, windowMs);
}
